import styled from 'styled-components';

import Colors from 'design/Colors';
import { fonts } from 'design/Fonts';
import { x } from 'design/Styled';
import Spacings from 'design/Spacings';

export const Content = styled.div`
  margin-bottom: ${Spacings.xSmall.margin};
`;

export const Title = styled.div`
  font: ${fonts.large.medium};
  color: ${Colors.TextDark};
  margin-bottom: ${Spacings.small.margin};
  text-align: center;
`;

export const ImageWrapper = styled.div`
  ${x};
  justify-content: center;
`;

export const Image = styled.img`
  height: 15em;
`;

export const SubTitle = styled.div`
  font: ${fonts.xSmall.regular};
  color: ${Colors.Text};
  text-align: center;
  margin-top: ${Spacings.small.margin};
  margin-bottom: ${Spacings.large.margin};

  button {
    margin-top: ${Spacings.large.margin};
  }
`;
